import { Outlet } from "react-router-dom";
import { Suspense } from "react";
import LoaderComponent from "@/shared/components/ui/LoaderComponent";

export interface AuthLayoutInterface {}

const AuthLayout: React.FC<AuthLayoutInterface> = () => {
  return <Suspense fallback={<LoaderComponent />}>
    <Outlet />
  </Suspense>;
};

export default AuthLayout;
